import React from 'react';
import classNames from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import {
  ButtonWrapper,
  ParagraphsRenderer,
  VariableRatiosPicture,
} from '../../../components';
import type { NodeLandingPage as Type } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface LandingPageProps {
  entity: ImmutableEntity<Type>;
  className?: string;
}

const NodeLandingPage: React.FC<LandingPageProps> = ({ entity, className }) => {
  const landingPage = entity.toJS();
  const heroTitle = landingPage.title[0].value;
  const heroBody = landingPage.body[0]?.processed;
  const heroImage = landingPage.field_media_item[0];

  const link = landingPage.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const linkSecondary = landingPage.field_link_secondary[0];
  const linkSecondaryTitle = linkSecondary?.title;
  const linkSecondaryUrl = linkSecondary?.alias || linkSecondary?.uri || '';
  const classes = classNames('Node', 'NodeLandingPage', className);

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <div className="NodeLandingPage__hero">
        <div className="NodeLandingPage__hero__image-wrapper">
          <div className="NodeLandingPage__hero__image">
            <VariableRatiosPicture
              image={heroImage}
              aspectRatios={['3_4', '4_3', '3_4', '16_9', '3_1']}
              cropSizes={['sm', 'md', 'lg', 'lg', 'xl']}
            />
          </div>
        </div>
        <Container className="NodeLandingPage__hero__text-container">
          <div className="NodeLandingPage__hero__text-wrapper">
            <div className="row">
              <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-1">
                <div className="NodeLandingPage__hero__text">
                  <h1 itemProp="title" className="NodeLandingPage__title">
                    {heroTitle}
                  </h1>

                  {heroBody && (
                    <WysiwygField
                      className="NodeLandingPage__body body--large"
                      property="schema:text"
                      html={heroBody}
                    />
                  )}

                  {(link || linkSecondary) && (
                    <div className="NodeLandingPage__links">
                      {link && (
                        <ButtonWrapper href={linkUrl} type="secondary">
                          {linkTitle}
                        </ButtonWrapper>
                      )}
                      {linkSecondary && (
                        <ButtonWrapper href={linkSecondaryUrl} type="textual">
                          {linkSecondaryTitle}
                        </ButtonWrapper>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <ParagraphsRenderer className="NodeLandingPage__paragraphs" paragraphs={entity.get('field_paragraphs')} />
    </article>
  );
};

export default NodeLandingPage;
